export default __webpack_public_path__ + "static/media/EveryoneGotWet_08.d7fac443.png";